<template>
  <div class="soutai">
    <h3>その他手当</h3>
    <div class="multi-date-table" v-for="(item, index) in form.sonota" :key="index">
      <div class="head"><b>その他手当{{ (index + 1) }}</b></div>
      <div class="item flex">
        <b class="width-55">手当</b>
        <p>{{ item.teate_name }}</p>
      </div>
      <div class="item flex">
        <b class="width-55">取得日</b>
        <p>{{ item.shinsei_date }}</p>
      </div>
    </div>
    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { Shinsei } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup() {
    return {
    };
  },
  components: {

  }
})
</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
